export default {
  mounted(el) {
    const handler = (e) => {
      if (e.key !== 'Enter' || e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) return;

      const tag = (e.target && e.target.tagName || '').toLowerCase();
      if (tag === 'textarea') return;

      const form = el.closest('[v-enter-to-next]') || el.closest('.counter-view') || document.body;

      const selector = `
        input:not([disabled]):not([type="hidden"]):not([aria-hidden="true"]),
        select:not([disabled]),
        textarea:not([disabled]),
        button:not([disabled]):not([type="button"]):not(.pointer-events-auto),
        button[data-transmitir],
        [tabindex]:not([tabindex="-1"])
      `;

      const all = form.querySelectorAll(selector);
      const focusables = Array.from(all)
        .filter(node => {
          if (node.offsetParent === null) return false;
          
          if (node.tagName === 'BUTTON' && 
              node.classList.contains('pointer-events-auto') && 
              !node.hasAttribute('data-transmitir')) {
            return false;
          }
          
          return true;
        });


      const idx = focusables.indexOf(e.target);

      if (idx === -1) {
        console.warn("⚠ TARGET NO ESTÁ EN LA LISTA");
        return;
      }

      e.preventDefault();

      const next = focusables[idx + 1];

      if (next) {
        next.focus();

        if (typeof next.select === "function" && next.tagName.toLowerCase() === "input") {
          next.select();
        }
      } else {

        const button =
          document.querySelector("button[data-transmitir]") ||
          document.querySelector(".transmitir-mtc");


        if (button) {
          button.focus();
          button.click();
        } else {
          e.target.blur();
        }
      }
    };

    el.addEventListener("keydown", handler);
    el._enterToNextHandler = handler;
  },

  unmounted(el) {
    if (el._enterToNextHandler) {
      el.removeEventListener("keydown", el._enterToNextHandler);
      delete el._enterToNextHandler;
    }
  }
};